import React from 'react';
import CommonDocument from './CommonDocument';

// Draft 用の props 名に合わせてラッピング
const Draft = ({
  contents,
  draftFigs,
  updateDraftFigs,
  showDraftProcessing,
  replaceGraphFlg = false,
}) => {
  return (
    <CommonDocument
      contents={contents}
      figs={draftFigs}
      updateFigs={updateDraftFigs}
      showProcessing={showDraftProcessing}
      replaceGraphFlg={replaceGraphFlg}
      // modifyDataFn は共通の modifyData をそのまま利用
    />
  );
};

export default Draft;
